export const getMood = (state, paletteType = "segment") =>
  state.colorPalette?.[paletteType]?.mood || "auto";

export const getScheme = (state, paletteType = "segment") =>
  state.colorPalette?.[paletteType]?.scheme || "auto";

export const getBaseColor = (state, paletteType = "wheel") =>
  state.colorPalette?.[paletteType]?.baseColor;

export const getPaletteColors = (state, type, paletteType = "segment") =>
  state.colorPalette?.[paletteType]?.[type] || [];

export const getSelectedWheelPalette = (state) =>
  state.colorPalette?.selectedWheelPalette;

export const getSelectedSegmentPalette = (state) =>
  state.colorPalette?.selectedSegmentPalette;

export const getSelectedSegmentColor = (state) =>
  state.colorPalette?.selectedSegmentColor;
